import { PayloadAction } from '@reduxjs/toolkit';

export const ControlCoverageLimitsSubQuestionReducer = {
	addLimits: (state: any, action: PayloadAction<any>) => {
		state.limits = action.payload.limits;
	},
	addPrefixes: (state: any, action: PayloadAction<any>) => {
		state.prefixes = action.payload.prefixes;
	},

	cleanCoverageLimits: (state: any, action: PayloadAction<any>) => {
		state.limits = {
			model: null,
			limit1: {},
			limit2: {},
			limit3: {},
		};
		state.prefixes = {
			limit1: {},
			limit2: {},
			limit3: {},
		};
	},
};
